import { addCurrencyToPrice } from 'utils/price';
import { SampleCatalogPlan } from 'types/generated/subscriptionsApi';
import getPlanPrices from 'helpers/getPlanPrices/getPlanPrices';
import { SampleCatalog } from '@landr/pricing/lib/types/generated';
import { GetDiscountedPlan } from 'hooks/useGetDiscountedPlan/useGetDiscountedPlan';

export const getSamplesPrice = ({
    samplesCatalog,
    getDiscountedPlan,
}: {
    samplesCatalog?: SampleCatalog;
    getDiscountedPlan: GetDiscountedPlan;
}) => {
    const sampleYearly = samplesCatalog?.plans.find(
        (plan: SampleCatalogPlan) => plan?.frequency === 'Yearly',
    );

    const discountedSamplesPro = getDiscountedPlan({
        planCode: 'samples_pro',
        frequency: 'Yearly',
    });

    const samplePrice = sampleYearly?.subscriptionPrice ?? 0;
    const sampleMonthlyEquivalentPrice = samplePrice / 12 ?? 0;

    const samplesPriceWithCurrency = addCurrencyToPrice(
        samplesCatalog?.currency ?? undefined,
        samplePrice / 12 ?? undefined,
    );

    const { monthlyEquivalentSalePrice: samplesMonthlyEquivalentSalePrice } =
        getPlanPrices({
            monthlyEquivalentPrice: sampleMonthlyEquivalentPrice,
            discountPercentage: discountedSamplesPro?.discountPercentage,
        });

    const samplesSalesWithCurrency = addCurrencyToPrice(
        samplesCatalog?.currency ?? undefined,
        samplesMonthlyEquivalentSalePrice ?? undefined,
    );

    return { samplesPriceWithCurrency, samplesSalesWithCurrency };
};
